import { action, computed, observable } from 'mobx';

export enum NavigationType {
    HOME,
    APPLICATION,
    STANDARD,
    NONE,
}

export type HomeNavigationBackground = 'mint-green' | 'white' | 'none';

export type HomeNavigationSpec = {
    type: NavigationType.HOME;
    background: HomeNavigationBackground;
    showMainMenu: boolean;
};

export type ApplicationNavigationSpec = {
    type: NavigationType.APPLICATION;
};

export type StandardNavigationSpec = {
    type: NavigationType.STANDARD;
};

export type NoneNavigationSpec = {
    type: NavigationType.NONE;
};

export type NavigationSpec =
    | HomeNavigationSpec
    | ApplicationNavigationSpec
    | StandardNavigationSpec
    | NoneNavigationSpec;

export class NavigationSpecs {
    static home(background: HomeNavigationBackground, showMainMenu: boolean = true): NavigationSpec {
        return {
            type: NavigationType.HOME,
            background,
            showMainMenu,
        };
    }
    static application(): NavigationSpec {
        return { type: NavigationType.APPLICATION };
    }
    static standard(): NavigationSpec {
        return { type: NavigationType.STANDARD };
    }
    static none(): NavigationSpec {
        return { type: NavigationType.NONE };
    }
}

export class NavigationState {
    @observable currentSpec: NavigationSpec = NavigationSpecs.none();

    @action.bound
    setSpec(spec: NavigationSpec) {
        this.currentSpec = spec;
    }

    @computed
    get currentType() {
        return this.currentSpec.type;
    }
}
